import type {AbtAttributesAction} from 'src/action-creators/action-based-targeting-meta';
import type {ActionAttributeSchema} from 'src/types/action-based-targeting-meta';
import {RECEIVE_ABT_ATTRIBUTES} from 'src/action-creators/action-based-targeting-meta';


export type State = {
  attributes: ActionAttributeSchema[];
};

const initialState = {
  attributes: [],
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly attributes: readonly []; }' is not assignable to type 'State'.
  state: State | null | undefined = initialState,
  action: AbtAttributesAction,
): State => {
  switch (action.type) {
    case RECEIVE_ABT_ATTRIBUTES: {
      return {
        ...state,
        attributes: action.payload,
      };
    }
  }
  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
};
